
import React, { useState } from 'react';

const AddOnsSection: React.FC = () => {
  const [activeTab, setActiveTab] = useState(0);

  const addOns = [
    {
      title: 'Web Design',
      description: 'Redesign your website with intelligent automation built in — optimized for conversion and engagement.',
      features: [
        'Conversion-optimized design',
        'AI chatbot integration',
        'Lead capture automation',
        'Mobile-responsive layouts',
        'Performance optimization'
      ],
      image: 'https://public.readdy.ai/ai/img_res/629e70374092387877fff639c2f6ac1f.jpg'
    },
    {
      title: 'Advanced Analytics',
      description: 'Deploy advanced AI analytics that track, analyze, and optimize your business performance in real-time.',
      features: [
        'Real-time performance tracking',
        'Predictive analytics',
        'Custom reporting dashboards',
        'ROI optimization',
        'Automated insights'
      ],
      image: 'https://readdy.ai/api/search-image?query=Minimalist%20analytics%20dashboard%20interface%2C%20clean%20white%20background%20with%20data%20visualization%2C%20modern%20charts%20and%20graphs%2C%20Apple-style%20design%20aesthetic%2C%20simple%20geometric%20elements%2C%20professional%20business%20intelligence%20platform&width=600&height=400&seq=analytics-apple&orientation=landscape'
    }
  ];

  return (
    <section id="add-ons" className="py-32 bg-gray-50">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-20">
          <h3 className="text-4xl md:text-5xl font-light text-black mb-6 tracking-tight">
            Additional solutions
          </h3>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto font-light leading-relaxed">
            Enhance your AI system with specialized services
          </p>
        </div>
        
        <div className="bg-white rounded-3xl p-12">
          {/* Tab Navigation */}
          <div className="flex justify-center gap-4 mb-12">
            {addOns.map((addOn, index) => (
              <button
                key={index}
                onClick={() => setActiveTab(index)}
                className={`px-6 py-3 rounded-full text-base font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                  activeTab === index
                    ? 'bg-black text-white'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {addOn.title}
              </button>
            ))}
          </div>
          
          {/* Tab Content */}
          <div className="grid md:grid-cols-2 gap-16 items-center">
            <div>
              <h4 className="text-3xl font-light text-black mb-6 tracking-tight">
                {addOns[activeTab].title}
              </h4>
              
              <p className="text-xl text-gray-600 mb-8 leading-relaxed font-light">
                {addOns[activeTab].description}
              </p>
              
              <div className="space-y-4">
                {addOns[activeTab].features.map((feature, index) => (
                  <div key={index} className="flex items-center space-x-3">
                    <div className="w-5 h-5 bg-black rounded-full flex items-center justify-center">
                      <i className="ri-check-line text-white text-xs"></i>
                    </div>
                    <span className="text-gray-700 text-base font-light">{feature}</span>
                  </div>
                ))}
              </div>
            </div>
            
            <div className="relative">
              <img
                src={addOns[activeTab].image}
                alt={addOns[activeTab].title}
                className="w-full h-96 object-cover rounded-3xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AddOnsSection;
